/**
 * 库存数量输入精度：管理员可输 4 位小数（用于调平历史尾差），普通账号保持 1 位。
 */

export function isInventoryQtyAdmin(userOrStore) {
  if (!userOrStore) return false
  // pinia store 或 user 对象
  if (userOrStore.isAdmin === true || userOrStore.isSuperuser === true) return true
  const u = userOrStore.user || userOrStore
  return !!(u?.is_admin || u?.is_superuser)
}

/** 管理员 4 位，其它 1 位（与历史报溢报损一致） */
export function inventoryQtyInputDecimals(userOrStore) {
  return isInventoryQtyAdmin(userOrStore) ? 4 : 1
}

export function inventoryQtyInputPrecision(userOrStore) {
  return inventoryQtyInputDecimals(userOrStore)
}

export function inventoryQtyInputStep(userOrStore) {
  return isInventoryQtyAdmin(userOrStore) ? 0.0001 : 0.1
}

export function inventoryQtyInputMin(userOrStore) {
  return isInventoryQtyAdmin(userOrStore) ? 0.0001 : 0.01
}

function _factor(decimals) {
  const d = Math.max(0, Math.min(8, Number(decimals) || 0))
  return 10 ** d
}

/** 按小数位四舍五入（非负） */
export function roundInventoryQty(n, decimals = 4) {
  if (n == null || !Number.isFinite(n)) return null
  if (n < 0) return null
  const f = _factor(decimals)
  return Math.round(n * f) / f
}

export function parseQtyInputToNumber(str, decimals = 4) {
  if (str == null || String(str).trim() === '') return null
  const n = parseFloat(String(str).replace(/,/g, '').trim())
  if (!Number.isFinite(n) || n < 0) return null
  return roundInventoryQty(n, decimals)
}

/** 写入输入框：整数不强制带小数点 */
export function formatQtyInputString(n, decimals = 4) {
  if (n == null || !Number.isFinite(n) || n < 0) return ''
  const r = roundInventoryQty(n, decimals)
  if (r == null || r === 0) return ''
  if (Number.isInteger(r)) return String(r)
  // 去掉多余尾随 0，但最多保留 decimals 位
  const fixed = r.toFixed(decimals)
  return String(parseFloat(fixed))
}

export function bumpQtyInputValue(cur, step, decimals = 4) {
  const base = cur == null || !Number.isFinite(cur) ? 0 : cur
  return roundInventoryQty(base + step, decimals)
}
